import React from 'react';

//Components
import {ChevronRight} from "react-feather";

//Styles
import Styles from './Shop.module.scss';

//Utils
import PropTypes from 'prop-types';

const Shop = ({shop: {name, street, zip, city}, onClick}) => (
    <button className={Styles.shop} onClick={onClick}>
        <div className={Styles.details}>
            <span className={Styles.name}>{name}</span>
            <span className={Styles.address}>{street}</span>
            <span className={Styles.address}>{`${zip} ${city}`}</span>
        </div>

        <div className={Styles.chevron}>
            <ChevronRight size={28}/>
        </div>
    </button>
);

Shop.propTypes = {
    shop: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired
};

export default Shop